<template>
    <div class="land-arch">
        <div class="arch-pic-container">
            <div class="container">
                <div class="pic-content">
                    <div class="arch-info">
                        <h2 v-html="salesCard.project_land_site.arch_title"></h2>
                        <h3 v-html="salesCard.project_land_site.arch_title_desc"></h3>
                    </div>
                </div>
            </div>
            <div class="pic-item" :style="'background-image: url(' + salesCard.project_land_site.arch_img + ')'"></div>
        </div>
        <div class="arch-pins">
            <div class="container">
                <div class="pin-items">
                    <div class="item" v-for="(item, index) in salesCard.project_land_site.arch_pins" :style="'width: calc(100%/' + salesCard.project_land_site.arch_pins.length + ' - 80px)'" :key="index">
                        <p>{{item.desc}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="arch-down-info" v-if="salesCard.project_land_site.arch_second_init == 'true'">
            <div class="container">
                <div class="column-container">
                    <div class="col-left">
                        <div class="desc-col" v-html="salesCard.project_land_site.arch_second_desc_left" v-if="salesCard.project_land_site.arch_second_desc_left != ''"></div>
                        <div class="col-img">
                            <img :src="salesCard.project_land_site.arch_second_img" alt="">
                        </div>
                    </div>
                    <div class="col-right">
                        <div class="desc-col-html" v-html="salesCard.project_land_site.arch_second_desc_right"></div>
                    </div>
                </div>  
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    export default {
        name: 'sale-land-arch',
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-arch.scss';
    @import '@/styles/respond/sales/sales-land-partials/land-arch-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>